import React from 'react'

import { Download } from '@mui/icons-material';
import './pageHeader.css'

interface pageHeaderParams{
    title: string;
    description: string;
    download?: string;
    // download?: () => void;
}

const PageHeader = ({title, description, download}: pageHeaderParams) => {
  return (
    <>
        <div className='page-header-wrapper'>
            <div className='page-header-main'>
                <h3>{title}</h3>
                <span>{description}</span>
            </div>
            <div className='page-head-report-download'>
                <div className='page-head-report-svg'><Download /></div>
                <span>{download}</span>
            </div>
        </div>
    </>
  )
}

export default PageHeader